import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useMetricSelectorStyles = makeStyles({
  container: {
    alignSelf: 'flex-end',
    display: 'flex',
    alignItems: 'center',
  },
  iconContainer: {
    width: '12px',
    height: '12px',
    display: 'flex',
    alignItems: 'center',
    ...shorthands.borderRadius('6px'),
    ...shorthands.borderStyle('solid'),
    ...shorthands.borderWidth('1px'),
    ...shorthands.borderColor(tokens.colorPaletteGreenBackground2),
    marginRight: '5px',
    justifyContent: 'center',
  },
  icon: {
    width: '4px',
    height: '4px',
    ...shorthands.borderRadius('4px'),
    ...shorthands.borderStyle('solid'),
    ...shorthands.borderWidth('2px'),
    ...shorthands.borderColor(tokens.colorStatusSuccessForeground1),
    backgroundColor: tokens.colorStatusSuccessForeground1,
  },
  button: {
    paddingTop: 0,
    paddingLeft: '5px',
    paddingRight: '0px',
    paddingBottom: '0px',
    width: 'fit-content',
  },
  buttonText: {
    ...shorthands.overflow('hidden'),
    lineBreak: 'anywhere',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

